import React, { useState } from "react";
import { Form, Formik, ErrorMessage, Field } from "formik";
import { Card, CardBody, Col, FormGroup, Label, Row, Spinner } from 'reactstrap'
import { DropdownList } from "react-widgets";
import * as Yup from "yup";
import GroupStatus from "../../../../../Components/IconDropdown/Cross_Tick/GroupStatus";

const CentralePlanning = ({ data, changeHandler, handleIconFieldChange, errorField }) => {
    const [loadingKeys, setLoadingKeys] = useState({})

    const orderDropdownNumber = data?.cntCtCoordinator;

    const defaultValues = {
        weergeven: Number(data?.lists?.cp?.hidden),
        autoload: Number(data?.lists?.cp?.iAutoLoad),
        uitzonderingWWZ: Number(data?.lists?.cp?.uitzondering),
        standaardStatus: data?.lists?.cp?.iFavoriet,
        order: data?.lists?.cp?.order
    }

    const validationSchema = Yup.object().shape({
        volgorde: Yup.number()
            .required("This field cannot be empty")
            .min(0, "Value cannot be negative"),
    });

    const handleToggle = (field, data, type) => {
        setLoadingKeys(prev => ({ ...prev, [field]: true }));
        handleIconFieldChange(field, data, type, setLoadingKeys)
    };

    return (
        <>
            <Card className="main-card">
                <CardBody className="d-flex flex-column">
                    <div className="btn-color-style travelCost-blue-text mb-4">Centrale planning</div>

                    <Formik
                        enableReinitialize
                        initialValues={defaultValues}
                        validationSchema={validationSchema}
                    >
                        {({ values, setFieldError, touched, errors, handleChange }) => (
                            <Form>
                                <Row>
                                    <Col sm={8} lg={5} xl={6} className="p-2">
                                        <FormGroup className="form-element min-height">
                                            <Label for="weergeven">Weergeven</Label>
                                            <div className="position-relative w-50">
                                                <div className="d-flex gap-1 align-items-center ">
                                                    {loadingKeys["hidden"] ? (
                                                        <div className="spinner-icon-change">
                                                            <div><Spinner size="sm" color="primary" /></div>
                                                        </div>
                                                    ) :
                                                        <GroupStatus iconChangeHandler={handleToggle} field={"hidden"} data={values?.weergeven ? 0 : 1} role={"0"} controlFrom={"contracttype"} />
                                                    }
                                                </div>
                                            </div>
                                        </FormGroup>

                                        <FormGroup className={`form-element min-height ${errorField === 'Afkorting' ? 'error' : ''} ${values.weergeven && ""}`}>
                                            <Label for="autoload">Autoload</Label>
                                            <div className="position-relative w-50">
                                                <div className="d-flex gap-1 align-items-center ">
                                                    {loadingKeys["iAutoLoad"] ? (
                                                        <div className="spinner-icon-change">
                                                            <div><Spinner size="sm" color="primary" /></div>
                                                        </div>
                                                    ) :
                                                        <GroupStatus iconChangeHandler={handleToggle} field={"iAutoLoad"} data={values?.autoload ? 0 : 1} role={"0"} controlFrom={"contracttype"} />
                                                    }
                                                </div>
                                            </div>
                                        </FormGroup>

                                        <FormGroup className={`form-element min-height ${errorField === 'Tarief' ? 'error' : ''}`}>
                                            <Label for="uitzondering WWZ">Uitzondering WWZ</Label>
                                            <div className="position-relative w-50">
                                                <div className="d-flex gap-1 align-items-center ">
                                                    {loadingKeys["uitzondering"] ? (
                                                        <div className="spinner-icon-change">
                                                            <div><Spinner size="sm" color="primary" /></div>
                                                        </div>
                                                    ) :
                                                        <GroupStatus iconChangeHandler={handleToggle} field={"uitzondering"} data={values?.uitzonderingWWZ ? 0 : 1} role={"0"} APIcall={false} controlFrom={"contracttype"} />
                                                    }
                                                </div>
                                            </div>
                                        </FormGroup>
                                    </Col>

                                    <Col sm={8} lg={5} xl={6} className="p-2">
                                        <FormGroup className="form-element">
                                            <Label for="standaardStatus">Standaard status</Label>
                                            <div className="position-relative w-50">
                                                <div className="d-flex gap-1 align-items-center">
                                                    <DropdownList dataKey='name' textField='name'
                                                        placeholder="Selecteer"
                                                        onChange={() => {
                                                            const data = values?.standaardStatus ? "0" : "1";
                                                            changeHandler('iFavoriet', data)
                                                        }}
                                                        name="standaardStatus"
                                                        value={values.standaardStatus === 0 ? "Aangevraagd" : "Ingepland"}
                                                        data={[{ name: "Aangevraagd", value: "0" }, { name: "Ingepland", value: "1" }]}
                                                        disabled={!values.weergeven ? false : true}
                                                    />
                                                    {errors.Status && <div className="text-danger">{errors.Status}</div>}
                                                </div>
                                            </div>
                                        </FormGroup>

                                        <FormGroup className={`form-element ${(errors.order) ? 'error' : ''}`}>
                                            <Label for="order">Volgorde</Label>
                                            <div className="position-relative w-50">
                                                <div className="d-flex gap-1 align-items-center">
                                                    <DropdownList dataKey='label' textField='label'
                                                        placeholder="Selecteer"
                                                        onChange={(e) => {
                                                            const data = e.label;
                                                            if (data) changeHandler("order", data, "0");
                                                        }}
                                                        name="order"
                                                        value={values.order}
                                                        data={Array.from({ length: orderDropdownNumber }, (_, i) => ({ label: i + 1 }))}
                                                        disabled={!values.weergeven ? false : true}
                                                    />
                                                </div>
                                                <ErrorMessage name="order" component="div" className="text-danger" />
                                            </div>
                                        </FormGroup>

                                    </Col>
                                </Row>
                            </Form>
                        )}
                    </Formik>
                </CardBody>
            </Card>
        </>
    )
}

export default CentralePlanning;